module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "configuration-view-wrapper new-company"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('companies.actions.update')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('p', {
    staticClass: "text-gray-color"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('companies.attributes.name')) + ":")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "company_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "name", $event.target.value)
      }
    }
  })]), _c('p', {
    staticClass: "text-gray-color"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('companies.attirbutes.emailDomain')) + ":")]), _c('span', [_vm._v("  " + _vm._s(_vm.company.email_domain))])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "account_setting"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.emailService')))]), _c('email-service-dropdown', {
    model: {
      value: (_vm.company.email_service),
      callback: function($$v) {
        _vm.$set(_vm.company, "email_service", $$v)
      },
      expression: "company.email_service"
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email_service')),
      expression: "errors.has('email_service')"
    }],
    key: "email_service",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('email_service')))])])], 1)])]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 plan"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('strong', {
    staticClass: "text-gray-color"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.companyStatus')) + ":")]), _c('div', {
    staticClass: "toggler-inline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleActiveCompany()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.company.active
    }
  }), _c('label', [_vm._v(_vm._s(_vm.company.active ? _vm.$t('companies.label.activeCompany') : _vm.$t('companies.label.pausedCompany')))])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "account_setting"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.plan')))]), _c('dropdown-select', {
    attrs: {
      "id": "account_setting",
      "options": _vm.company.account_setting_options().account_settings,
      "selected": _vm.account_setting_selected
    },
    model: {
      value: (_vm.account_setting_selected),
      callback: function($$v) {
        _vm.account_setting_selected = $$v
      },
      expression: "account_setting_selected"
    }
  })], 1), (_vm.account_setting_selected) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('max_number_of_regular_users')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "max_number_of_regular_users"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.maxUsersCount')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          between: [_vm.regular_users_bottom_limit, _vm.regular_users_upper_limit]
        }
      }),
      expression: "{ rules: { required: true, between: [regular_users_bottom_limit, regular_users_upper_limit] } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account_setting.max_number_of_regular_users),
      expression: "account_setting.max_number_of_regular_users"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "max_number_of_regular_users",
      "name": "max_number_of_regular_users",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account_setting.max_number_of_regular_users)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account_setting, "max_number_of_regular_users", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "max_number_of_regular_users": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('max_number_of_regular_users')),
      expression: "errors.has('max_number_of_regular_users')"
    }],
    key: "max_number_of_regular_users",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('max_number_of_regular_users')))])])], 1) : _vm._e(), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('max_number_of_monitoring_managers')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "max_number_of_monitoring_managers"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.maxManagersCount')))]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.account_setting.max_number_of_monitoring_managers),
      expression: "account_setting.max_number_of_monitoring_managers"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "max_number_of_monitoring_managers",
      "name": "max_number_of_monitoring_managers",
      "type": "text"
    },
    domProps: {
      "value": (_vm.account_setting.max_number_of_monitoring_managers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.account_setting, "max_number_of_monitoring_managers", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "max_number_of_monitoring_managers": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('max_number_of_monitoring_managers')),
      expression: "errors.has('max_number_of_monitoring_managers')"
    }],
    key: "max_number_of_monitoring_managers",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('max_number_of_monitoring_managers')))])])], 1)])]), _c('hr'), _c('div', {
    staticClass: "row voip-edit"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('strong', {
    staticClass: "text-gray-color"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.voip')) + ":")]), _c('div', {
    staticClass: "toggler-inline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleVoipService()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.voip_active
    }
  }), _c('label', [_vm._v(_vm._s(_vm.voip_active ? _vm.$t('general.label.active') : _vm.$t('general.label.inactive')))])])])]), (_vm.voip_active) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "voip_service"
    }
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.service')))]), _c('dropdown-select', {
    attrs: {
      "id": "voip_service",
      "options": _vm.voip_services,
      "selected": _vm.voip_service
    },
    on: {
      "input": _vm.setVoipService
    },
    model: {
      value: (_vm.voip_service),
      callback: function($$v) {
        _vm.voip_service = $$v
      },
      expression: "voip_service"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "text-gray-color"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.paidMinutes')) + ":")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.max_duration_in_minutes),
      expression: "max_duration_in_minutes"
    }],
    staticClass: "form-control minutes max-duration",
    attrs: {
      "name": "max_duration"
    },
    domProps: {
      "value": (_vm.max_duration_in_minutes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.max_duration_in_minutes = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "text-gray-color"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.paidMinutesUsedOnMonth')))]), _c('span', {
    staticClass: "minutes text-light-gray-color"
  }, [_vm._v(_vm._s(_vm.plivo_setting && _vm.plivo_setting.voip_monthly_plan.consumed_in_minutes()) + " " + _vm._s(_vm.$t('general.label.minutes')))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('span', {
    staticClass: "text-gray-color"
  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.additionalMinutes')))]), _c('button', {
    staticClass: "btn btn-default btn-primary btn-xs",
    staticStyle: {
      "margin-left": "10px",
      "padding": "1px 5px",
      "font-size": "12px"
    },
    on: {
      "click": _vm.addMinutes
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  })]), _vm._l((_vm.plivo_setting.voip_additional_times), function(additional_minute) {
    return _c('additional-minute', {
      attrs: {
        "additional": additional_minute
      }
    })
  })], 2)]) : _vm._e()]), _c('br'), _c('router-link', {
    staticClass: "btn btn-gray",
    attrs: {
      "to": "/configuracoes/empresas"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fb3416c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/companies/edit.vue
// module id = 1089
// module chunks = 1